__webpack_require__.p = "/skote/react-ts/h-light/";